/**
 * index.js
 *
 * @Author: wangyinan
 * @Date: 2018/2/6 下午3:03
 */

import AutoComplete from './AutoComplete';

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/autoComplete/index.js